import uniqid from 'uniqid'
import { projects } from '../../portfolio'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

const Projects = () => {
  if (!projects.length) return null

  return (
    <section id='projects' className='section projects'>
      <h2 className='section__title'>Projects</h2>
      <p className='section__subtitle'>Selected work spanning product launches, experiments, and learning builds.</p>

      <div className='projects__grid'>
        {projects.map((project) => (
          <ProjectContainer key={project.name || uniqid()} project={project} />
        ))}
      </div>
    </section>
  )
}

export default Projects
